// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getVm(comments) {
  return List.map((function (param) {
                return {
                        created_at: Timestamp$Catalyst.toString(param.created_at, "DD/MM/YY hh:mm a"),
                        commenter: param.commenter,
                        comment: param.comment
                      };
              }), comments);
}

export {
  getVm ,
  
}
/* Timestamp-Catalyst Not a pure module */
